module.exports = require("ramda");


//////////////////
// WEBPACK FOOTER
// external "ramda"
// module id = ramda
// module chunks = 3